import { useQuery } from "@tanstack/react-query";
import { Container } from "react-bootstrap";
import Swal from "sweetalert2";
import useFilterParams from "../../../hooks/useFilterParams";
import { getAuthMethod } from "../../../modules/helper";
import MainMenu from "../../../modules/public/mainMenu/mainMenu";
import DigikalaCoworkerListFilters from "./DigikalaCoworkerListFilters";
import DigikalaCoworkerListTable from "./DigikalaCoworkerListTable";
import PaginateCard from "../../../components/PaginateCard";

export default function DigikalaCoworkerList() {
  const filters = useFilterParams({
    page: 1,
    items: 10,
  });

  const { data, refetch, isFetching } = useQuery({
    queryKey: ["DigikalaCoworkerList"],
    queryFn: () =>
      getAuthMethod("/v1/digikala/coworker/list", filters.getAllParams()).then(
        res => {
          if (res && res.status === 200) {
            return res.data.data;
          }

          Swal.fire({
            title: "دریافت اطلاعات با خطا مواجه شد",
            confirmButtonText: "متوجه شدم",
            icon: "error",
            confirmButtonColor: "red",
          });
          return { count: 0, items: [] };
        }
      ),

    placeholderData: { count: 0, items: [] },
    refetchOnWindowFocus: false,
    gcTime: 0,
  });

  return (
    <MainMenu>
      <Container>
        <DigikalaCoworkerListFilters
          isFetching={isFetching}
          refetch={refetch}
        />

        <DigikalaCoworkerListTable
          count={data.count}
          isFetching={isFetching}
          items={data.items}
        />

        <PaginateCard
          className="my-4"
          count={data.count}
          numberItems={filters.getParam("items")}
          numberPage={filters.getParam("page")}
          onIndexChoose={page => {
            filters.setParam("page", page);
            refetch();
          }}
        />
      </Container>
    </MainMenu>
  );
}
